var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "app" } },
    [_c("router-view", { attrs: { "app-state": _vm.state } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }